export enum Breakpoint {
  xs = 0,
  sm = 480,
  md = 640,
  lg = 820,
}
